import { apiService } from '../../../shared/services/apiServices';
import equipmentEndpoints from './equipmentEndpoints';

export interface EquipmentFileItem {
  url?: string | null;
  filename?: string;
  fileSize?: number;
  fileType?: string;
  path?: string;
  resourceId?: string;
  isUploaded?: boolean;
}

export interface EquipmentListItem {
  id: string;
  equipmentId: string;
  name: string;
  description: string;
  category?: string | undefined;
  categoryLabel?: string | undefined;
  serialNumber?: string | undefined;
  modelName?: string | undefined;
  dateOfProduction?: string | undefined;
  status: string;
  image?: EquipmentFileItem | null | undefined;
  docs?: EquipmentFileItem[] | undefined;
}

export interface EquipmentPaginationMeta {
  page: number;
  limit: number;
  totalCount: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface ListEquipmentData {
  equipment: EquipmentListItem[];
  pagination: EquipmentPaginationMeta;
}

export interface ListEquipmentParams {
  clientId: string;
  facilityId: string;
  page?: number;
  limit?: number;
  search?: string;
  isValid?: boolean;
}

export interface ListEquipmentResult {
  success: boolean;
  data?: ListEquipmentData;
  error?: string;
  accessDenied?: boolean;
}

export const listEquipment = async (
  params: ListEquipmentParams
): Promise<ListEquipmentResult> => {
  try {
    const {
      clientId,
      facilityId,
      page = 1,
      limit = 10,
      search,
      isValid,
    } = params;

    const query = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });
    if (search) {
      query.set('search', search);
    }
    if (isValid !== undefined) {
      query.set('isValid', String(isValid));
    }

    const base = equipmentEndpoints.LIST_EQUIPMENT(clientId, facilityId);
    const endpoint = `${base}?${query.toString()}`;

    const result = await apiService.getAPI(endpoint, {
      skipGlobalErrorRedirect: true,
    });

    if (result.error) {
      if (result.status === 403) {
        return { success: false, accessDenied: true };
      }
      return {
        success: false,
        error: 'Nie udało się załadować listy urządzeń.',
      };
    }

    return { success: true, data: result.data as ListEquipmentData };
  } catch {
    return { success: false, error: 'Wystąpił nieoczekiwany błąd.' };
  }
};
